import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CreateIcon from '@mui/icons-material/Create';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import { BEM_NAME_ELEMENTS } from '../_const';

/**
 * Breadcrumb navigation
 * @param {string} currentPageLabel
 * @param {boolean} isSearch
 * @param {any} props
 * @returns navigation
 */
const PageWithBreadcrumbs = ({
	currentPageLabel,
	previousPageLabel = 'Epic Administration Home',
	previousPageLink = '/EpicUtilities/Home',
	isSearch,
	...props
}) => {
	const history = useHistory();
	const CurrentPageIcon = isSearch ? SearchIcon : CreateIcon;

	const currentPageStyles = {
		display: 'flex',
		alignItems: 'center',
		cursor: 'default',
	};

	const linkStyles = {
		...currentPageStyles,
		cursor: 'pointer',
	};

	return (
		<>
			<Box sx={{ pb: 3 }}>
				<Breadcrumbs
					sx={{ paddingTop: '4px' }}
					maxItems={7}
					aria-label='breadcrumb'
				>
					<Link
						underline='hover'
						color='text.secondary'
						onClick={() => history.push('/index.html')}
						sx={{
							...linkStyles,
						}}
						id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--ims-home`}
					>
						<HomeIcon sx={{ mr: 0.5 }} fontSize='inherit' />
						IMS Home
					</Link>
					<Link
						underline='hover'
						color='text.secondary'
						onClick={() => history.push(previousPageLink)}
						sx={{ ...linkStyles }}
						id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--epic-home`}
					>
						<AdminPanelSettingsIcon
							sx={{ mr: 0.5 }}
							fontSize='inherit'
						/>
						{previousPageLabel}
					</Link>
					<Typography
						color='text.primary'
						sx={{ ...currentPageStyles }}
						id={`${BEM_NAME_ELEMENTS.VIEW_BREADCRUMBS}__${BEM_NAME_ELEMENTS.FIELD_LINK}--current-page`}
					>
						<CurrentPageIcon sx={{ mr: 0.5 }} fontSize='inherit' />
						{currentPageLabel}
					</Typography>
				</Breadcrumbs>
			</Box>
			{props.children}
		</>
	);
};

export default PageWithBreadcrumbs;
